import css from 'styled-jsx/css'

import { colors } from '../../theme'


export default css`
nav {
  display: flex;
  background: ${colors.midnightExpress};
  color: ${colors.pureWhite};
  position: fixed;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translateX(100%);
  overflow: hidden;
  z-index: 20;
  transition: transform 200ms ease-in-out;
  overflow-y: auto;
}

nav.open {
  transform: translateX(0);
}
`
